import React, { createRef } from 'react'
import Header from '../common/header/header'
import Footer from '../common/footer/footer'
import '../login/login.css'
import { userService } from './../../services/user.service';
import Validate from './../common/validate';
import { Redirect } from 'react-router-dom';
import CommonMessage from './../common/commonMessage';
import ReactTooltip from 'react-tooltip';
import $ from 'jquery'
import { API_HOST,axiosRequest } from './../../constants/server.constant';
import Axios from 'axios';

class Resetpassword extends React.Component{
    constructor(props){
        super(props)
        this.state ={
            hidePwd : true,
            isPwdShown : false,
            hidePwd1 : true,
            isPwdShown1 : false,
            username : "",
            password : "",
            confirmPwd : "",
            pswd : false,
            confirmpswd:false,
            token : "",
            isPswdMatch:false,
            passwordregex : false,
            isAction : false,
            passwordSuccess:false,
            passwrodError:false,
            successMsg : false,
            redirect:false

           
        }
        this.textInput = React.createRef()
        this.passwordToggle = this.passwordToggle.bind(this)
        this.submitForm = this.submitForm.bind(this)
        this.handleInput = this.handleInput.bind(this)
        this.confirmPwdToggle = this.confirmPwdToggle.bind(this)
    }
    componentDidMount(){
        document.title = "IDrive® Compute | Update password"
        // const link = document.createElement("link")
        // link.href = "https://www.idrivecompute.com/webapp/css/login-page.css"
        // link.rel = "stylesheet"
        // link.type = "text/css"
        // document.head.appendChild(link)

        // const link1 = document.createElement("link")
        // link1.href = "https://www.idrivecompute.com/webapp/css/static-common.css"
        // link1.rel = "stylesheet"
        // link1.type = "text/css"
        // document.head.appendChild(link1)

        this.setState({
            token : this.props.match.params.token,
            username : this.props.match.params.username,
            isAction:true
        },()=>this.checkToken(this.state.token))
    }
    checkToken = (token)=>{
        Axios.get(API_HOST+"/user/recover/"+token+"?type=fromComponent",axiosRequest)
        .then(resp=>{
          
            this.setState({
                isAction:false
            })
            if(resp.data == "INVALID_TOKEN"){
                this.props.history.push("/password-expired")
            }
            if(resp.data == "ERROR"){
                this.props.history.push("/error")
            }
        })
        .catch(error=>{
            this.setState({
                isAction:false
            })
        })
    }
    handleInput(event){
        let name = event.target.name
        let val = event.target.value
        this.setState({
            [name]:val,
            pswd:false,
            confirmpswd : false,
            isPswdMatch:false,
            passwordregex:false,
            passwrodError:false
        })
        if(name == "password") {
            var upCasePatt = new RegExp("[A-Z]")
            if(upCasePatt.test(val)) {
                $('#upperCaseLi').addClass("success")
            } else {
                $('#upperCaseLi').removeClass("success")
            }
            var lowCasePatt = new RegExp("[a-z]")
            if(lowCasePatt.test(val)) {
                $('#lowerCaseLi').addClass("success")
            } else {
                $('#lowerCaseLi').removeClass("success")
            }
            var numericPatt = new RegExp("[0-9]");
            if(numericPatt.test(val)) {
                $('#numericLi').addClass("success")
            } else {
                $('#numericLi').removeClass("success")
            }
            var specCharPat = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
            if(specCharPat.test(val)) {
                $('#specCharLi').addClass("success")
            } else {
                $('#specCharLi').removeClass("success")
            }
            if(val.length >= 8) {
                $('#eightCharLi').addClass("success")
            } else {
                $('#eightCharLi').removeClass("success")
            }
        }
    }
    passwordToggle(event)
    {   
        this.setState({
                hidePwd : !this.state.hidePwd,
                isPwdShown : !this.state.isPwdShown
         })
        this.textInput.current.focus()
      
    }
    confirmPwdToggle(){
        this.setState({
            hidePwd1 : !this.state.hidePwd1,
            isPwdShown1 : !this.state.isPwdShown1
        })
    }
    submitForm(event){
        event.preventDefault()
        
        if(this.state.password.length <=0){
            this.setState({
                pswd : true
            })
            $('#password').focus();
            return
        }
        if(this.state.confirmPwd.length <=0){
            this.setState({
                confirmpswd : true
            })
            $('#confirmPwd').focus();
            return
        }
        if(this.state.password !== this.state.confirmPwd){
            this.setState({
                isPswdMatch : true
            })
            $('#confirmPwd').focus();
            return
        }
        if(!Validate("password",this.state.password)){
            this.setState({
                passwordregex : true
            })
            $('#password').focus();
            return
        }
        this.setState({
            isAction:true
        })
        userService.updateforgotpassword(this.state.token,this.state.confirmPwd).then((resp)=>{
           
            if(resp === false){
                this.setState({
                    passwrodError : true,
                    isAction:false
                })
                return
            }
            if(!resp.data.error){
                this.setState({
                    successMsg : true,
                    isAction:false,
                    redirect : true
                })
               
            }
            else{
                this.setState({
                    passwrodError : true,
                    isAction:false
                })
             } 
           

        })

    }
    checkInput = (event,type)=>{
        event.preventDefault()
        
        if(type === "new"){
            if(this.state.password.length >0){
                this.setState({
                    pswd : false
                })
                if(!Validate("password",this.state.password)){
                    this.setState({
                        passwordregex : true
                    })
                   
                }
            }
            else{
                this.setState({
                    pswd : true
                })
            }
        }
        else{
            if(this.state.confirmPwd.length >0){
                this.setState({
                    confirmpswd : false
                })
            }
            else{
                this.setState({
                    confirmpswd : true
                })
            }
        }
    }
    
    render(){
        if(this.state.redirect){
            return <Redirect to={{
                pathname: "/login",
                state:{fromResetPass:true}
            }}></Redirect>
        }
        return(
          <div>
             
            <Header />
            <div className="body_inner">
                <main className="static">
                    <div id="static_form_wrap">
                        <div className="sign_in_bg"></div>
                        <div className="wrapper">
                            <div className="box_center_align">
                                <form id="signin-form">
                                    <div className="box_header_text">
                                        <h1>Update Password</h1>
                                    </div>
                                    <div className="box_inner_wrap">
                                        <div className="msg_box">
                                            <div className="common_msg success" style = {{display : this.state.successMsg?"block": "none"}}>
                                            <div class="icon"></div>
                                                <div className="info"> <strong>Success</strong><br></br>
                                                Your password has been updated </div>
                                            </div>
                                        </div>
                                        <div className="msg_box">
                                            <div className="common_msg error" style = {{display : this.state.passwrodError?"block": "none"}}>
                                                <div className="info">Password failed to update</div>
                                            </div>
                                        </div>
                                       <div className = 'reset_pwd'>
                                            <div className="user_name_fetch">Email: <span className="fetch_email">{this.state.username}</span></div>
                                            <p className="title_info">Enter a new password for your IDrive® Compute account.</p>
                                            <div className="inp_row">
                                                <label>New password</label>
                                                <div className=" pwd-icon pwd_field_wrap">
                                                    <input type={this.state.hidePwd ? "password":"text"} autoFocus ={true}  ref = {this.textInput} name="password" id="password" className="txt-box" onChange = {this.handleInput}></input>
                                                    <div className="id-tooltip id-tooltip-topright">
                                                            <p className="id-tooltip-note">Use atleast:</p>
                                                            <ul>
                                                                <li id="upperCaseLi">1 uppercase character</li>
                                                                <li id="lowerCaseLi">1 lowercase character</li>
                                                                <li id="numericLi">1 numerical digit</li>
                                                                <li id="specCharLi">1 special character</li>
                                                                <li id="eightCharLi">Min 8 characters </li>
                                                            </ul>
                                                    </div>
                                                    <span data-tip data-for="password" class={this.state.isPwdShown?"pwd_field_eyeIcon show_pwd":"pwd_field_eyeIcon"} onClick = {(e)=>this.passwordToggle(e)}></span>
                                                </div><ReactTooltip  id="password" place="right" effect="solid">
                                                            {this.state.isPwdShown?"Hide":"Show"} 
                                                        </ReactTooltip>
                                                <span className="error_msg" style={{display:this.state.pswd?"block" :"none"}}>Password cannot be blank</span>
                                                <span className="error_msg" style={{display:this.state.passwordregex?"block" :"none"}}>Password must meet the criteria</span>
                                            </div>
                                            <div className="inp_row">
                                                <label>Confirm password</label>
                                                <div className=" pwd-icon pwd_field_wrap">
                                                <input type={this.state.hidePwd1 ? "password":"text"} name="confirmPwd" id="confirmPwd" className="txt-box" onChange = {(e)=>this.handleInput(e)} onFocus = {(e)=>this.checkInput(e,"new")} onBlur = {(e)=>this.checkInput(e,"confirm")}></input>
                                                <span data-tip data-for="cofirmpassword"  class={this.state.isPwdShown1?"pwd_field_eyeIcon show_pwd":"pwd_field_eyeIcon"} onClick = {this.confirmPwdToggle}></span>
                                               
                                                </div><ReactTooltip  id="cofirmpassword" place="right" effect="solid">
                                                            {this.state.isPwdShown1?"Hide":"Show"} 
                                                        </ReactTooltip>
                                                <span className="error_msg" style={{display:this.state.confirmpswd?"block" :"none"}}>Confirm password cannot be blank</span>
                                                <span className="error_msg" style={{display:this.state.isPswdMatch?"block" :"none"}}>New password and confirmation password must be the same</span>
                                            </div>
                                                <div className="footer_wrap"> 
                                                <div className = {this.state.isAction?"btn_wrap loginSubmitLoader":"btn_wrap"}>    
                                                    <input type="submit" name="" value={this.state.isAction?"":"Update"} className="btn-primary g-recaptcha"  data-sitekey="6LfvAiwUAAAAANov16A_dcQhR952_39cma0Itaof" data-callback="onSubmit" data-size="invisible" onClick={this.submitForm}></input>
                                                </div>
                                                </div>
                                       </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </main>
                <div className="clear"></div>
                <Footer/>
                </div>
                <CommonMessage message={this.state.message} handler={()=>this.setState({message:""})}/>
            </div>
        ) 
    }
}

export default Resetpassword